import { observer } from "mobx-react-lite";
import React, { FunctionComponent, useEffect } from "react";
import { Virtuoso } from "react-virtuoso";
import AttributesContainer from "./AttributesContainer";
import { useCustomViewAttributesStore } from "./CustomViewAttributesStore";

const AttributesContainers: FunctionComponent = observer(() => {
	const attributesStore = useCustomViewAttributesStore();
	const { onRenderLevel, selectedContainer, selectedLevel, selectedLevel: { displayContainers } } = attributesStore;

	useEffect(onRenderLevel, [selectedContainer, selectedLevel]);

	return (
		<Virtuoso
			data={displayContainers}
			data-csi-automation="AttributesList"
			increaseViewportBy={250}
			initialItemCount={displayContainers.length}
			itemContent={(_, container) => (
				<AttributesContainer
					container={container}
					key={container.uniqueId}
				/>
			)}
			style={{ height: "100%", width: "100%" }}
		/>
	);
});

export default AttributesContainers;